import React from 'react';
import './TourDetails.css';

const TourDetails = () => {
  const features = [
    {
      icon: '🏍️',
      title: 'Professional Guide',
      description: 'Local rider with intimate knowledge of every curve and the best stops along the route.'
    },
    {
      icon: '🏨',
      title: 'Premium Lodging',
      description: '1-2 nights in carefully selected accommodations with motorcycle-friendly amenities.'
    },
    {
      icon: '🍽️',
      title: 'Group Meals',
      description: '2 group dinners and 2 breakfasts featuring local cuisine and rider camaraderie.'
    },
    {
      icon: '🗺️',
      title: 'Route Briefings',
      description: 'Daily route briefings and curated stops at the most scenic and historic locations.'
    },
    {
      icon: '🏍️',
      title: 'Ride Your Own Bike',
      description: 'Bring a well-maintained motorcycle. Rentals and fuel are not included in the package price.'
    },
    {
      icon: '🏆',
      title: 'Souvenir Patch',
      description: 'Exclusive "I Rode the Devil\'s Highway 666" patch to commemorate your adventure.'
    }
  ];

  const hazards = [
    'Hairpin turns requiring advanced riding skills',
    'Mountain terrain with elevation changes up to 5,000 feet',
    'No edge rails on many sections',
    'Occasional rocks and pine needle debris',
    'Wildlife crossings (elk, deer, cows)',
    'Occasional rain showers and weather changes'
  ];

  return (
    <section id="tour-details" className="tour-details section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Tour Details</h2>
          <p className="section-subtitle">
            Experience an adventure of a lifetime riding the legendary (and dangerous) Devil's Highway with professional guidance and full support
          </p>
        </div>

        <div className="tour-overview">
          <div className="overview-content">
            <h3>The Devil's Highway Experience</h3>
            <p>
              The Devil's Highway (US 191, formerly Route 666) is America's most twisted road, 
              featuring 650+ curves over 120 miles through the rugged and scenic Southwest. This isn't your 
              typical highway cruise—it's a technical riding challenge that rewards skilled riders 
              with breathtaking scenery and unforgettable memories.
            </p>
            <p>
              Our 3-day, 2-night guided tour covers 666+ total miles through Arizona and New Mexico, 
              taking you from the iconic Route 66 to the legendary "Highway to Hell" and back. 
              Positioned as a bucket list ride comparable to the Tail of the Dragon, but in the rugged Southwest style 
              with its own unique challenges and rewards.
            </p>
          </div>
          <div className="overview-stats">
            <div className="stat-card">
              <span className="stat-number">650+</span>
              <span className="stat-label">Curves</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">120</span>
              <span className="stat-label">Miles of Twists</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">9,000</span>
              <span className="stat-label">Ft Elevation</span>
            </div>
            <div className="stat-card">
              <span className="stat-number">666+</span>
              <span className="stat-label">Total Miles</span>
            </div>
          </div>
        </div>

        <div className="features-grid">
          <h3 className="features-title">What's Included</h3>
          <div className="features-container">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h4 className="feature-title">{feature.title}</h4>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="hazards-section">
          <div className="hazards-content">
            <h3>Important: Know the Hazards</h3>
            <p>
              The Devil's Highway is not for beginners. This is an advanced riding experience 
              that requires skill, concentration, and respect for the road. Please review these 
              hazards and ensure you're prepared for the challenge.
            </p>
            <ul className="hazards-list">
              {hazards.map((hazard, index) => (
                <li key={index} className="hazard-item">
                  <span className="hazard-icon">⚠️</span>
                  {hazard}
                </li>
              ))}
            </ul>
            <div className="hazards-warning">
              <strong>Rider Requirements:</strong> Advanced riding skills, full protective gear, 
              and a well-maintained motorcycle are mandatory. This tour is not suitable for 
              beginners or riders uncomfortable with technical mountain roads.
            </div>
          </div>
        </div>

        <div className="route-info">
          <h3>
            Meetup Options <br/>
            <span className="stop-icon">🔥</span>
            Route 66 to 666
          </h3>
          <h4>

            </h4>
          <div className="route-stops">
            <div className="route-stop">
              <span className="stop-icon">🏁</span>
              <div className="stop-info">
                <h4>Phoenix</h4>
                <p>Starting point for our adventure</p>
              </div>
            </div>
            <div className="route-stop">
              <span className="stop-icon">🎵</span>
              <div className="stop-info">
                <h4>Winslow <br/>Route 66</h4>
                <p>Standing on the corner...</p>
              </div>
            </div>
            <div className="route-stop">
              <span className="stop-icon">🏕️</span>
              <div className="stop-info">
                <h4>Holbrook <br/>Route 66</h4>
                <p>Wigwam Motel - iconic Route 66 experience</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default TourDetails;
